import { DefaultDeliveryLocations } from '../types'
import type { LacedAvailableLocales } from 'types/localisation'

type LocaleToCountry = {
  [K in LacedAvailableLocales]: DefaultDeliveryLocations
}

const localeToCountry: LocaleToCountry = {
  en: 'GB',
  fr: 'FR',
  de: 'DE'
}

export default localeToCountry
